import { render, staticRenderFns } from "./CommonPageHeader.vue?vue&type=template&id=474d6d44"
import script from "./CommonPageHeader.vue?vue&type=script&lang=js"
export * from "./CommonPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports